import React from "react";
import { Flex } from "@chakra-ui/react";

const ListInformationSystem = () => {
    return (
        <Flex>
        <h2>Sistemas de Información</h2>
        </Flex>
    )
    
}

export default ListInformationSystem;